export default {
  setLanguage(state, payload) {
    state.global.lang = payload;
  },
  setTechAccess(state, payload) {
    state.global.technicalAccess = payload;
  },
  setAccessMode(state, payload) {
    state.global.accessMode = payload;
  },
  setLoading(state, payload) {
    state.global.loading = payload;
  }
};
